<template>
  <vx-card no-shadow>

    <h2 class="mb-6">General</h2>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Venue name</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-input class="w-full" v-model="name" />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Description</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <textarea class="vs-inputx vs-input--input normal" style="height:200px;font-family: Arial;line-height: 1.5rem;" spellcheck="false" v-model="description" placeholder="Venue description..." />
      </div>
    </div>

    <vs-divider />

    <div class="vx-col lg:w-1/1 w-full">
      <h5 class="mb-6">Tags</h5>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
      <span>Tags</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <vs-chips color="rgb(145, 32, 159)" placeholder="New Tag" v-model="tags">
          <vs-chip
            :key="tag"
            @click="removeTag(tag)"
            v-for="tag in tags" closable>
            {{ tag }}
          </vs-chip>
        </vs-chips>
      </div>
    </div>

    <vs-divider />

    <div class="vx-col lg:w-1/1 w-full">
      <h5>Photos &amp; Videos</h5>
    </div>
    <VenueImages v-if="venue" :venue="venue" style="width: 100%;" />

    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end">
      <vs-button @click="saveInfo" id="save-button" class="ml-auto mt-2">Save General</vs-button>
    </div>
  </vx-card>
</template>

<script>

const VenueImages = () => import("./components/VenueImages.vue");

export default {
  components: {
    VenueImages
  },

  data () {
    return {
      tags: [],

      venueId: null,

      name: '',
      description: '',
      venue: null
    }
  },
  methods: {
    removeTag (item) {
      this.tags.splice(this.tags.indexOf(item), 1)
    },

    getInfo: function () {
      this.$vs.loading()

      this.$http.get(process.env.VUE_APP_API +'/venue/' + this.venueId + '/info/general')
          .then(resp => {
            this.name = resp.data.name;
            this.description = resp.data.description;

            if (resp.data.tags) {
              this.tags = resp.data.tags;
            } else {
              this.tags = [];
            }

            this.venue = resp.data;
            this.venue.id = this.venueId;

            console.log(this.venue)
          })
          .catch(err => {
            console.log(err)

            this.$vs.notify({
              color:'danger',
              title:'Error',
              text:'Could not fetch venue: ' + err
            });
          })
          .finally(() => {
            this.$vs.loading.close()
          })
    },

    saveInfo: function () {
      this.$vs.loading({
        background:'primary',
        color:'#fff',
        container: "#save-button",
        scale: 0.45
      })

      const payload = {
        name: this.name,
        description: this.description,
        tags: this.tags
      };

      this.$http.put(process.env.VUE_APP_API +'/venue/' + this.venueId + '/info/general',  payload)
          .then((/*resp*/) => {
            this.$vs.notify({
              color:'success',
              title:'Success',
              text:'Venue saved'
            });
          })
          .catch(err => {
            console.log(err);

            this.$vs.notify({
              color:'danger',
              title:'Error',
              text:'Could not save venue: ' + err
            });
          })
          .finally(() => {
            this.$vs.loading.close("#save-button > .con-vs-loading")
          })
    }
  },
  mounted() {
    this.venueId = this.$route.params.venueId;
    console.log(this.venueId);

    this.getInfo();
  }
}
</script>

<style lang="scss" scoped>
.con-chips--remove-all {
  display: none;
}
</style>